module.exports = __webpack_public_path__ + "img/nissan-370z.569cc7eb.jpg";